import React from "react";

import "./Select.scss";

const Select = ({
  label = "",
  options = [{ value: "No-Values", caption: "No Values" }],
  placeholder = "Choose...",
}) => {
  return (
    <div className='selectContainer'>
      <label htmlFor='select'>{label}:</label>
      <input id='select' list='selectList' placeholder={placeholder} />
      <datalist id='selectList'>
        {options.map((listItem) => {
          return <option data-value={listItem.value} value={listItem.caption}></option>;
        })}
      </datalist>
    </div>
  );
};

export default Select;
